import Form from "../../../../components/forms/index";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { Troubleshoot } from "@mui/icons-material";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { useLazyGetShopCategoriesQuery, useCreateShopMutation } from "../../../../features/shop/shopApiSlice";
const FarmingForm = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [shopCategoryone, setShopCategoryone] = useState();
  const [isloading, setIsloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });
  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    marketPlace: "",
    image: [""],
    isFoodShop: false,
    shopCategory: "",
    businessType: "farmingShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      shopCategory: categoryid
    }
    ))
  }, [categoryid]);

  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [createShopMutation] = useCreateShopMutation();

  useEffect(() => {
    getShopCategories({ type: 'farmingShop', parentCategory: '' }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategoryone(response?.data?.Category);
        }
      })
      .catch((error) => {
      });
  }, []);

  const PostShopData = async (e) => {
    setIsloading(true);
    e.preventDefault();
    try {
      const response = await createShopMutation(createShop).unwrap();
      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Form Farming Created Successfully");
          navigate(`/rawmaterial-farming/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed To Create Shop");
    }
  };
  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }
  return (
    <>
      <Form
        title="Fill to create Farming Shop"
        butn="Create"
        back="/farming-integrate"
        CreateHandler={PostShopData}
        setCreateShop={setCreateShop}
        createShop={createShop}
        shopCategoryone={shopCategoryone}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </>
  );
};

export default FarmingForm;
